module.exports = __webpack_public_path__ + "static/img/course-outline.155629e5.png";